import isEmptyObject from '#shared/util/isEmptyObject.js';

import cLogo from '#themes/default/default/components/logo/logo.js';
import cTooltip from '#themes/default/default/components/tooltip/tooltip.js';

import template from './formLine.html' with { type: 'html' };

export default {
	name: 'CFormLine',
	components: {
		cLogo,
		cTooltip
	},
	props: {
		customClass: {
			type: String,
			default: ''
		},
		customer: {
			type: Object,
			default: () => null
		},
		errorMessage: {
			type: String,
			default: ''
		},
		hasIframe: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		isEmpty: {
			type: Boolean,
			default: true
		},
		label: {
			type: String,
			default: ''
		},
		labelFor: {
			type: String,
			required: true
		},
		note: {
			type: String,
			default: ''
		},
		order: {
			type: Object,
			default: () => null
		},
		paymentType: {
			type: String,
			default: ''
		},
		reference: {
			type: String,
			default: ''
		},
		references: {
			type: Object,
			default: () => null
		},
		size: {
			type: String,
			default: 'medium'
		},
		suggestions: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		value: {
			type: [String, Number]
		},
		hasErrorFromParent: {
			type: Boolean,
			default: false
		},
		hasAccountNote: {
			type: Boolean,
			default: false
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			hasError: false,
			adaptiveErrorObject: null
		};
	},
	computed: {
		isFilled() {
			return this.value || !this.isEmpty;
		},
		suggestion() {
			return this.suggestions;
		},
		hasSuggestion() {
			return !isEmptyObject(this.suggestion);
		},
		showAccountNote() {
			return !this.hasSuggestion || !(this.suggestion.shouldBeGmail && this.suggestion.fixedEmail || !this.suggestion.doesDomainExist);
		},
		adaptiveErrorMessage() {
			// Get the error code from the adaptive error object
			const { code } = Object.assign({}, this.adaptiveErrorObject);
			// Build the localization key and check if we have know the key
			const localizationKey = `form_error_${code}`;
			const localizationString = this.$store.state.localization[localizationKey];
			// Return the adaptive error message or fallback to the default one from props
			return localizationString ? this.t(localizationKey) : this.errorMessage;
		},
		brand() {
			return this.theme.brand;
		},
		logoDesign() {
			return 'light';
		}
	},
	mounted() {
		this.$el.addEventListener('click', this.replaceInvalidGmailDomain);
	},
	methods: {
		onChange(target) {
			this.hasError = Boolean(target.error);
		},
		focusProvidersElementAndHideTooltip(event) {
			// Hide tooltip if visible
			document.body.click();
			if (!this.reference || !this.references[this.reference]) {
				event.stopPropagation();
			}
		},
		replaceInvalidGmailDomain(event) {
			event.preventDefault();
			if (event.target.classList.contains('formLine_suggestionTarget')) {
				this.customer.billing.email = `${this.suggestion.fixedEmail.email}@${this.suggestion.fixedEmail.domain}`;
				this.suggestion.doesDomainExist = true;
				this.suggestion.shouldBeGmail = false;
				this.tracking.emailTypoClick({
					order: this.order
				}, this.suggestion.originalDomain, this.suggestion.fixedEmail.domain);
			}
		},
		setAdaptiveError(adaptiveErrorObject) {
			this.adaptiveErrorObject = adaptiveErrorObject;
		}
	},
	template
};
